import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getFrameworkAgreementsCount = (expired) => {
  const queryString = qs.stringify({ expired });
  return axios.get(
    `/api/framework_agreements/count?${queryString}`
  );
};

export const useFrameworkAgreementsCount = (expired = false, options = {}) => {
  return useQuery(
    `framework-agreements-expired-${expired}-count`,
    () => getFrameworkAgreementsCount(expired),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}